import { AuthResponse } from '@/api/client';
import Cookies from 'js-cookie';

interface AuthTokens {
  accessToken: string;
  refreshToken?: string;
}
const ACCESS_TOKEN_COOKIE =
  import.meta.env.VITE_ACCESS_TOKEN_COOKIE_NAME || 'access_token';

const REFRESH_TOKEN_COOKIE =
  import.meta.env.VITE_REFRESH_TOKEN_COOKIE_NAME || 'refresh_token';

export const hasTokens = (): boolean => {
  const accessToken = Cookies.get(ACCESS_TOKEN_COOKIE);
  const refreshToken = Cookies.get(REFRESH_TOKEN_COOKIE);
  return !!(accessToken && refreshToken);
};

export const getTokens = (): AuthTokens => {
  const accessToken = Cookies.get(ACCESS_TOKEN_COOKIE) || '';
  const refreshToken = Cookies.get(REFRESH_TOKEN_COOKIE) || '';

  return { accessToken, refreshToken };
};

export const setTokens = (tokens: AuthResponse): void => {
  const isSecure = window.location.protocol === 'https:';

  const accessTokenExpiryDays =
    Number(import.meta.env.VITE_ACCESS_TOKEN_EXPIRY_DAYS) || 1;

  const refreshTokenExpiryDays =
    Number(import.meta.env.VITE_REFRESH_TOKEN_EXPIRY_DAYS) || 7;

  Cookies.set(ACCESS_TOKEN_COOKIE, tokens.access, {
    secure: isSecure,
    sameSite: 'strict',
    expires: accessTokenExpiryDays,
  });

  if (tokens?.refresh) {
    Cookies.set(REFRESH_TOKEN_COOKIE, tokens.refresh, {
      secure: isSecure,
      sameSite: 'strict',
      expires: refreshTokenExpiryDays,
    });
  }
};

export const clearTokens = (): void => {
  Cookies.remove(ACCESS_TOKEN_COOKIE);
  Cookies.remove(REFRESH_TOKEN_COOKIE);
};
